import { LocalizedTypography } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Banner, Typography } from '@optimus-web/core';
import { useAppConfiguration } from '@mews-commander/data-access';
import { PlatformEnvironment } from '@mews/enums';

export const SecurityInstructionsBanner = () => {
    const env = useAppConfiguration().environment;
    const showBanner = env === PlatformEnvironment.Production || env === PlatformEnvironment.Development;

    if (!showBanner) {
        return null;
    }

    return (
        <Banner
            variant="info"
            primaryText={
                <LocalizedTypography
                    textStyle="bodyMedium"
                    textKey={TextKey.LoginInstructionsBanner}
                    substitutes={{
                        strong: (text) => (
                            <Typography textStyle="bodyMediumStrong" as="span">
                                {text}
                            </Typography>
                        ),
                    }}
                    as="div"
                />
            }
        />
    );
};
